export const AUTH_AI_PREVIEW_HEADLINE = "This isn't another place to manage work. This is where work gets done."

export const AUTH_AI_PREVIEW_PILL_LABEL = 'vAI is working on your order...'

export const AUTH_AI_PREVIEW_STEPS = [
  'Read the order from email and PO',
  'Enriched the customer from the web',
  'Requested the missing billing info',
  'Routed to a senior coordinator',
  'Placing the order in NetSuite...',
  'Capturing the order number',
] as const

export const AUTH_AI_PREVIEW_STEP_STATES = {
  done: 'done',
  active: 'active',
  pending: 'pending',
} as const

/** Time one step stays in progress before it completes. */
export const AUTH_AI_PREVIEW_STEP_INTERVAL_MS = 1600

/**
 * Row the active card is pinned to once the list starts scrolling (0-based).
 * Also the row the reduced-motion snapshot rests on — it matches the design frame.
 */
export const AUTH_AI_PREVIEW_PINNED_STEP_INDEX = 4

/** Card height plus the gap below it, in px. */
export const AUTH_AI_PREVIEW_ROW_HEIGHT_PX = 71
